export const prepareDbgUtilDef = () => ({
  prnt: (obj: unknown) => console.log(JSON.stringify(obj, null, 2)),
});
